export enum EventStatusEnum {

    Unread = 0,
    Read = 1

}